import React from "react";
import { ketoFacts, benefits } from "../mock";
import ContactSection from "../components/ContactSection";
import { Leaf, Heart, Sparkles, Truck } from "lucide-react";

const iconFor = (i) => {
  const icons = [Leaf, Heart, Sparkles, Truck];
  const I = icons[i % icons.length];
  return <I size={22} />;
};

export default function WhatIsKetoPage() {
  return (
    <div className="fade-in">
      <section className="bg-[var(--ka-cream)]">
        <div className="container-ka pt-16 pb-12 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-block text-[12px] tracking-[0.25em] uppercase text-[var(--ka-teal)] mb-3">
              The Basics
            </span>
            <h1 className="font-serif text-5xl md:text-6xl text-[var(--ka-teal-darker)] mb-5">
              What is Keto?
            </h1>
            <p className="text-[var(--ka-muted)] text-lg leading-relaxed">
              The ketogenic diet shifts your body from burning sugar to burning
              fat. Done right, it can transform your weight, energy and focus.
              Here&apos;s a quick guide.
            </p>
          </div>
          <div className="hero-frame">
            <img
              src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&q=80"
              alt="Keto ingredients"
              className="w-full h-[380px] object-cover"
            />
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container-ka grid grid-cols-1 md:grid-cols-2 gap-10">
          {ketoFacts.map((f) => (
            <article
              key={f.title}
              className="p-7 bg-[var(--ka-cream)] rounded-md"
            >
              <h2 className="font-serif text-3xl text-[var(--ka-teal-darker)] mb-3">
                {f.title}
              </h2>
              <p className="text-[var(--ka-text)]/85 leading-relaxed">
                {f.body}
              </p>
            </article>
          ))}
        </div>
      </section>

      <section className="section bg-[var(--ka-teal)] text-white">
        <div className="container-ka">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl">
              Why people love it
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((b, i) => (
              <div
                key={b.title}
                className="p-7 bg-white/5 border border-white/10 rounded-md backdrop-blur-sm"
              >
                <div className="w-12 h-12 rounded-full bg-white text-[var(--ka-teal)] inline-flex items-center justify-center mb-4">
                  {iconFor(i)}
                </div>
                <h3 className="font-serif text-2xl mb-2">{b.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">{b.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container-ka max-w-3xl text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-[var(--ka-teal-darker)] mb-5">
            Ready to get started?
          </h2>
          <p className="text-[var(--ka-muted)] mb-8">
            Tell us a little about your goals and we&apos;ll recommend the
            perfect plan.
          </p>
          <a href="#contact" className="btn-teal">
            Talk to our nutritionist
          </a>
        </div>
      </section>

      <ContactSection />
    </div>
  );
}
